// App.js
import './styles/global.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import EventCarousel from './components/EventCarousel';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Products from './pages/Products';
import Solutions from './components/Solutions';
import Downloads from './pages/Downloads';
import Educacional from './pages/Educacional';
import Planos from './pages/Planos';
import AreaCliente from './pages/AreaCliente';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <EventCarousel />
              <Hero />
              <Solutions />
              <Team />
              <Contact />
            </>
          } />
          <Route path="/produtos" element={<Products />} />
          <Route path="/educacional" element={<Educacional />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/planos" element={<Planos />} />
          <Route path="/area-cliente" element={<AreaCliente />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
